module.exports = __webpack_public_path__ + "img/Mockup 2.23554166.png";